import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import { GetAllVisibleNodesAsync } from "motw_core/Workflows/GetVisibleNodes";
import { WithAnimatedProgressBarAsync } from "source/app/presentation/Header/ProgressBar/LevelProgressBar/WithAnimatedProgressBar";
import { GetWorkflowsState } from "source/app/presentation/MainPanel/Workflows/Workflows";
import { LogWorkflowNavigation } from "source/app/services/Workflows/WorkflowNavigationDiagnostics";

export async function RefreshVisibleWorkflowNodesAsync(
    rootNode?: IWorkflowNode
) {
    const workflows = GetWorkflowsState();

    if (!workflows) {
        return;
    }

    rootNode = rootNode ?? workflows.state.rootNode;

    LogWorkflowNavigation("RefreshVisibleWorkflowNodes:start", {
        rootNodeId: rootNode.id,
    });

    const visibleNodes = await WithAnimatedProgressBarAsync(
        () => GetAllVisibleNodesAsync(rootNode!),
        `RefreshVisibleWorkflowNodes_GetAllVisibleNodesAsync`
    );

    LogWorkflowNavigation("RefreshVisibleWorkflowNodes:finish", {
        rootNodeId: rootNode.id,
        visibleNodeCount: visibleNodes?.length ?? 0,
    });

    workflows.setState({ visibleNodes: visibleNodes ?? [] });
}
